import { ErrorMessage, useField } from "formik";
import React from "react";
import * as ReactIconsGI from "react-icons/gi";

interface Props {
  label: string;
  name: string;
  type?: "text" | "email" | "password";
  placeholder?: string;
  reactIcon?: string;
  strong?: boolean;
  [x: string]: any;
}

export const FormikText = ({ label, reactIcon, ...props }: Props) => {
  const IconComponent = reactIcon ? ReactIconsGI[reactIcon] : null;
  const [field, meta] = useField(props);
  return (
    <>
      {label ? (
        <label
          htmlFor={props.id || props.name}
          className={`${props.strong ? "font-bold absolute" : ""}`}
        >
          {/* {label}{" "} */}
        </label>
      ) : (
        ""
      )}
      <div
        className={`col m-0 p-0 input-group relative ${
          meta.touched && meta.error && ""
        }`}
      >
        <span
          className="input-group-text border-1 border-skin-primary/50 bg-skin-primary/25 text-skin-primary font-bold"
          id="basic-addon1"
        >
          {reactIcon && IconComponent ? (
            <IconComponent size={24} />
          ) : (
            <>
              <i
                className={`${
                  meta.touched && meta.error && "has-error-icon animate-pulse"
                } ${props.icon}`}
              ></i>{" "}
            </>
          )}
        </span>
        <input
          className={`peer form-control font-semibold !rounded-r-[5px] z-auto ${
            meta.touched && meta.error && "bg-skin-cardBody"
          }  border-1 border-skin-primary/50 border-l-0 appearance-none`}
          autoComplete="current-pasword"
          id={props.name}
          placeholder={" "}
          {...field}
          {...props}
        />{" "}
        <div className="absolute z-50 flex right-3 mt-2 w-auto">
          <ErrorMessage
            name={props.name}
            render={(msg) => (
              <div className="tooltip-container ">
                <i className="i-warning text-danger animate-ping"></i>
                <div className="tooltip">{msg}</div>
              </div>
            )}
            className="i-warning text-danger "
          />
        </div>{" "}
        <label htmlFor={props.name}
          className={`absolute left-14 -top-3 px-2 transition-all duration-300 ease-in-out font-bold cursor-text text-sm bg-skin-cardBody text-skin-primary/60 z-[5]
          peer-placeholder-shown:top-2 peer-placeholder-shown:text-base  peer-placeholder-shown:scale-100 peer-placeholder-shown:bg-skin-cardBody peer-placeholder-shown:text-skin-primary/75
          peer-focus:-top-3 peer-focus:text-sm peer-focus:text-skin-primary/60`}
        >
          {label}
          {""}
        </label>
      </div>
    </>
  );
};
